import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
// eslint-disable-next-line no-unused-vars
import { ApplicationFragment } from "components/fragments"
import tw, { styled } from "twin.macro"
import ConditionalLink from "components/conditional-link"
import ManualMoreLink from "components/manual-more-link"
import IndustrySlider from "components/industry-slider"
import PurpleDot from "images/icons/purple-circle.inline.svg"
import ButtonLE from "components/button-le"

export const Profile = styled.div`
  ${tw`py-16 m:py-32 px-2 flex flex-wrap-reverse l:flex-wrap justify-start items-start mx-auto max-w-s m:max-w-m l:max-w-l`}
  font-size: 15px;
  line-height: 27px;
  p,
  li {
    margin-top: 1.5rem;
  }

  &.product {
    ${tw`pt-0 pb-16 m:pb-32 flex-wrap space-y-8 l:space-y-0`}

    h2 {
      ${tw`text-left py-0 leading-none`}
    }

    p:first-child {
      ${tw`mt-0`}
    }

    img.image {
      border-radius: 5px;
    }

    p.description {
      ${tw`mt-10 l:mt-14`}
    }

    &.product-group {
      ${tw`pt-24 m:pt-32 pb-0`}

      h2.product-profile {
        ${tw`mb-3`}
      }
    }
  }
`

export const Title = styled.h2`
  ${tw`py-2 w-full font-display font-bold text-white text-center m:text-left`}
  font-size: 25px;
  line-height: 25px;
  @media (min-width: 640px) {
    font-size: 35px;
    line-height: 35px;
  }
  @media (min-width: 1024px) {
    font-size: 44px;
    line-height: 55px;
  }

  &.product {
    ${tw`w-auto`}
  }

  &.product-profile {
    ${tw`mb-3`}
  }
`

export const Body = styled.div`
  h2 {
    ${tw`font-display text-yellow`}
    font-size: 18px;
    line-height: 20px;

    @media (min-width: 640px) {
      line-height: 27px;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    padding-left: 1em;
    text-indent: -0.7em;
  }

  li > div {
    display: inline;
  }

  li::before {
    content: "• ";
    color: #f7bc2d;
  }

  &.product {
    li::before {
      color: #ffffff;
    }

    h2 {
      ${tw`mb-12`}
    }
  }
`

const Dot = styled(PurpleDot)`
  position: absolute;
  height: 10px;
  width: 10px;
  left: 50%;
  margin-left: 0px;
  margin-top: 20px;
`

export default () => {
  const data = useStaticQuery(graphql`
    query INDUSTRY_PROFILES {
      gcms {
        industries: industriesConnection(first: 100, orderBy: order_ASC) {
          edges {
            node {
              title
              body {
                html
              }
              mainApplications {
                ...ApplicationData
              }
              mediumApplications {
                ...ApplicationData
              }
              applications {
                ...ApplicationData
              }
              thumbnailImage {
                url
              }
              slug
            }
          }
        }
      }
    }
  `)
  const [hovered, setHovered] = useState(false)
  const industries = data.gcms.industries.edges
  return (
    <>
      {industries.map(({ node }, idx) => {
        const applications = node.mainApplications
          .concat(node.mediumApplications)
          .concat(node.applications)
        return (
          <Profile className="text-white font-body" key={idx}>
            <div className="w-full l:w-5/12">
              <IndustrySlider
                data={applications}
                industry={node}
                bg={node.thumbnailImage ? node.thumbnailImage.url : undefined}
              />
            </div>
            <div className="hidden l:flex w-1/12 relative">
              <Dot />
            </div>
            <div className="w-full l:w-1/2">
              <ManualMoreLink active={hovered} type="profile" className="mb-3">
                <ConditionalLink
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                  to={`/industry/${node.slug}`}
                >
                  <Title className="industry-card whitespace-nowrap">{node.title}</Title>
                </ConditionalLink>
              </ManualMoreLink>
              <Body
                dangerouslySetInnerHTML={{
                  __html: `<div>${node.body.html}</div>`,
                }}
              />
              <ButtonLE
                to={`/industry/${node.slug}`}
                className="mt-6"
                color="purple"
              >
                Find out more
              </ButtonLE>
            </div>
          </Profile>
        )
      })}
    </>
  )
}
